import React from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { GraduationCap, BookOpen, Award, TrendingUp } from 'lucide-react';

const Education = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a1e 0%, #1a0a2e 100%)',
      padding: '2rem',
      color: '#fff'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{
            fontSize: '3rem',
            background: 'linear-gradient(135deg, #00ffff, #00ff88)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '1rem',
            fontWeight: 'bold'
          }}>
            Education & Learning
          </h1>
          <p style={{ color: '#888', fontSize: '1.1rem', maxWidth: '800px', margin: '0 auto' }}>
            AI-powered education in psychology, metaphysics, sociology, and cognitive resilience
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '1.5rem',
          marginBottom: '3rem'
        }}>
          <Card style={{
            padding: '1.5rem',
            background: 'rgba(0, 255, 255, 0.1)',
            border: '1px solid rgba(0, 255, 255, 0.3)'
          }}>
            <GraduationCap size={32} style={{ color: '#00ffff', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Psychology</h3>
            <p style={{ color: '#888' }}>Understanding human behavior and consciousness</p>
          </Card>

          <Card style={{
            padding: '1.5rem',
            background: 'rgba(138, 43, 226, 0.1)',
            border: '1px solid rgba(138, 43, 226, 0.3)'
          }}>
            <BookOpen size={32} style={{ color: '#8a2be2', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Metaphysics</h3>
            <p style={{ color: '#888' }}>Exploring reality, existence, and consciousness</p>
          </Card>

          <Card style={{
            padding: '1.5rem',
            background: 'rgba(0, 255, 136, 0.1)',
            border: '1px solid rgba(0, 255, 136, 0.3)'
          }}>
            <Award size={32} style={{ color: '#00ff88', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Sociology</h3>
            <p style={{ color: '#888' }}>Social systems and collective behavior</p>
          </Card>
        </div>

        <Card style={{
          padding: '2rem',
          background: 'rgba(10, 10, 30, 0.8)',
          border: '1px solid rgba(0, 255, 255, 0.3)',
          marginBottom: '2rem'
        }}>
          <h2 style={{ fontSize: '1.5rem', color: '#00ffff', marginBottom: '1.5rem' }}>Learning Features</h2>
          <div style={{ color: '#888', lineHeight: '1.8' }}>
            <p>Comprehensive educational tools and systems:</p>
            <ul style={{ marginTop: '1rem', paddingLeft: '2rem' }}>
              <li>Structured Learning Pathways</li>
              <li>Interactive Courses & Modules</li>
              <li>AI Tutoring & Personalized Learning</li>
              <li>Progress Tracking & Achievements</li>
              <li>Community Discussion Forums</li>
              <li>Certification Programs</li>
              <li>Temple of Thought (AI Reflection System)</li>
            </ul>
          </div>
        </Card>

        <Card style={{
          padding: '2rem',
          background: 'linear-gradient(135deg, rgba(0,255,255,0.1), rgba(0,255,136,0.1))',
          border: '2px solid #00ffff'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <TrendingUp size={32} style={{ color: '#00ffff' }} />
            <h2 style={{ fontSize: '1.5rem', color: '#00ffff' }}>Education AI Advisor</h2>
          </div>
          <p style={{ color: '#ccc', marginBottom: '1.5rem' }}>
            Get personalized learning guidance from AI educators and tutors. Ask about courses, 
            learning strategies, topics, or any educational question.
          </p>
          <Button style={{
            background: 'linear-gradient(135deg, #00ffff, #00ff88)',
            color: '#000',
            fontWeight: 'bold',
            padding: '1rem 2rem'
          }}>
            Chat with Education AI
          </Button>
        </Card>
      </div>
    </div>
  );
};

export default Education;